import {Helmet} from "react-helmet-async";
import {FiExternalLink} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {TabContentContainer} from "@/components/layout/TabContentContainer.tsx";
import {UPTIME_STATUSPAGE_URL} from "@/lib/constants/links.ts";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {useTabs} from "@/lib/hooks/useTabs.tsx";
import {MonitoringServersList} from "@/pages/monitoring/monitoringservers/MonitoringServersList.tsx";
import {PrivateLocationsList} from "@/pages/monitoring/privatelocations/list/PrivateLocationsList.tsx";

enum MonitoringServersTabs {
  PUBLIC = "public",
  PRIVATE = "private",
}

export const MonitoringServersPage = () => {
  const {tab, changeTab} = useTabs({
    defaultTab: MonitoringServersTabs.PUBLIC,
    tabList: Object.values(MonitoringServersTabs),
  });

  return (
    <TabContentContainer
      sections={{
        [MonitoringServersTabs.PUBLIC]: {
          id: MonitoringServersTabs.PUBLIC,
          title: "Public",
          isVisible: true,
        },
        [MonitoringServersTabs.PRIVATE]: {
          id: MonitoringServersTabs.PRIVATE,
          title: "Private",
          isVisible: true,
        },
      }}
      title="Probe Servers"
      tab={tab}
      setTab={changeTab}
      actionsBar={
        <Button
          variant={"secondary"}
          size={"large"}
          as={"a"}
          href={`${UPTIME_STATUSPAGE_URL}?subscribe`}
          target={"_blank"}
        >
          Public Status <Icon icon={FiExternalLink} />
        </Button>
      }
    >
      <Helmet>
        <title>Probe Servers</title>
      </Helmet>
      <UpErrorBoundary>
        {tab === MonitoringServersTabs.PUBLIC && <MonitoringServersList />}
        {tab === MonitoringServersTabs.PRIVATE && <PrivateLocationsList />}
      </UpErrorBoundary>
    </TabContentContainer>
  );
};
